// extracted by mini-css-extract-plugin
var _1 = "PostTopicWithBreadcrumbs-module__animatedBackground--mN28T";
var _2 = "PostTopicWithBreadcrumbs-module__container--POOI4";
var _3 = "PostTopicWithBreadcrumbs-module__content--i2sS0";
var _4 = "16px";
var _5 = "PostTopicWithBreadcrumbs-module__innerContainer--lnaId";
var _6 = "PostTopicWithBreadcrumbs-module__isEditing--bhsDn";
var _7 = "PostTopicWithBreadcrumbs-module__large--Qz6uJ";
var _8 = "PostTopicWithBreadcrumbs-module__link--ekbis";
var _9 = "PostTopicWithBreadcrumbs-module__noAncestor--J95g3";
var _a = "PostTopicWithBreadcrumbs-module__popOverReference--FbXQt";
var _b = "PostTopicWithBreadcrumbs-module__remove--_2J0E";
var _c = "PostTopicWithBreadcrumbs-module__removeButton--lo60k";
var _d = "PostTopicWithBreadcrumbs-module__topicName--sQtpK";
var _e = "PostTopicWithBreadcrumbs-module__topicNameInner--VBrYt";
var _f = "PostTopicWithBreadcrumbs-module__topicPublicView--FZ5Jx";
export { _1 as "animatedBackground", _2 as "container", _3 as "content", _4 as "iconSize", _5 as "innerContainer", _6 as "isEditing", _7 as "large", _8 as "link", _9 as "noAncestor", _a as "popOverReference", _b as "remove", _c as "removeButton", _d as "topicName", _e as "topicNameInner", _f as "topicPublicView" }
